import { AvatarName } from '@setplex/tria-api'
import { createStore } from 'effector'
import { register } from '~/core/repository'

export const KidsProfilesMap: { id: string; image: string }[] = [
  {
    id: AvatarName.FOX,
    image: '/img/kidsprofiles/profile_fox.png',
  },
  {
    id: AvatarName.RACOON,
    image: '/img/kidsprofiles/profile_racoon.png',
  },
  {
    id: AvatarName.HAMSTER,
    image: '/img/kidsprofiles/profile_hamster.png',
  },
  {
    id: AvatarName.MOOSE,
    image: '/img/kidsprofiles/profile_moose.png',
  },
  {
    id: AvatarName.ZEBRA,
    image: '/img/kidsprofiles/profile_zebra.png',
  },
  {
    id: AvatarName.RABBIT,
    image: '/img/kidsprofiles/profile_rabbit.png',
  },
]

export const $kidsProfiles = createStore(KidsProfilesMap)

register($kidsProfiles, '$shared/ui/KidsProfiles/kidsProfiles')
